import Vue from 'vue';
import Vuex from 'vuex'
import App from './App.vue';
import router from './router'
import Vuetify from "vuetify";
import '@mdi/font/css/materialdesignicons.css'
import "vuetify/dist/vuetify.min.css";
import vuetify from './plugins/vuetify';
import VueResource from 'vue-resource';
import 'es6-promise/auto'
import store from './store/index'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from './aws-exports'
import VueBarcodeScanner from 'vue-barcode-scanner'
import { apolloClient } from './vue-apollo'
// import { apolloClientDB } from './vue-apollo-db'
import VueApollo from 'vue-apollo'
import terminalStore from './store/terminalStore'
import axios from "axios";
import {Auth} from 'aws-amplify'
/*
// Electron event examples - always check if window.bmElectron exists
if (window.bmElectron) {
  window.bmElectron.send('print-request', 'Initialized');
  window.bmElectron.on('print-response', (event, args) => {});
}
*/

Amplify.configure(awsconfig)
Amplify.configure(awsExports)

Vue.use(VueResource, Vuex, Vuetify)
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.use(VueBarcodeScanner)

const awsExports = {
  Auth: {
    region: process.env.VUE_APP_REGION,
    userPoolId: process.env.VUE_APP_COGNITO_POOL_ID,
    userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,
    authenticationFlowType: 'USER_PASSWORD_AUTH'
  }
}

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
})
Vue.config.productionTip = false
store.modules = { ...store.modules, terminalStore }
const s = new Vuex.Store(store)
const apolloProvider = new VueApollo({
  // clients: {
  //   default: apolloClient,
  //   queryClient: apolloClientDB
  // },
  defaultClient: apolloClient
})

// Add a request interceptor

axios.interceptors.request.use(async config => {
  // Do something before request is sent
  if(!(config.withCredentials === false)){
    const data = await Auth.currentSession();
    config.headers.Authorization = "Bearer " + data.accessToken.jwtToken
  }
  // logging
  if(s.state.debugModeOn){ s.dispatch('appendAxioLogs', {...config, type:'Request', time: new Date()}) }
  return config;
}, err =>{
  if(s.state.debugModeOn){ s.dispatch('appendAxioLogs', {...err, type:'Response', time: new Date()})}
  Promise.reject(err);
}) 

// Add a response interceptor
axios.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  if(s.state.debugModeOn){ s.dispatch('appendAxioLogs', {...response, type:'Response', time: new Date()})}
  return response;
}, function (error) {
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if(error === 'No current user') {
    window.bmTerminalApp.$store.commit("setNoCurrentUser", true)
  }
  if(s.state.debugModeOn){ s.dispatch('appendAxioLogs', {...error?.response, type:'Response', time: new Date()})}
  return Promise.reject(error);
});

const bmTerminalApp = new Vue({
  router,
  store:s,
  vuetify,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')

window.addEventListener('beforeunload', () => {
  bmTerminalApp.$destroy();
});

window.bmTerminalApp = bmTerminalApp
